export default "__VITE_ASSET__BV92BIDX__"